<template>
  <div :class="['text-container', _isMobile && 'mobile']">
    <breadcrumb v-if="!_isMobile" :list="breadList"></breadcrumb>
     <div v-else class="banner-logo">
      <img src="@/assets/image/header-logo.png" alt="广播影视人才交流中心" />
    </div>
    <div v-if="open" class="search-wrapper">
      <p class="title">证书查询</p>
      <!-- <p class="sub-title">广电总局人才中心行业教育培训证书查询</p> -->
      <i class="line"></i>
      <div class="form-container">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="form.name" placeholder="请填写姓名" @input="clearRules('name')">
              <img src="../../assets/certificate-icon/name-icon.png" alt="" slot="prefix" >
            </el-input>
            <!-- <p class="error" v-if="showError"><i class="el-icon-warning"></i>{{ errText }}</p> -->
          </el-form-item>
          <el-form-item prop="idCard">
            <el-input v-model="form.idCard" placeholder="请填写身份证号" @input="clearRules('idCard')">
              <img src="../../assets/certificate-icon/idCard-icon.png" alt="" slot="prefix" >
            </el-input>
          </el-form-item>
          <el-form-item prop="num">
            <el-input v-model="form.num" placeholder="请填写证书编号" @input="clearRules('num')">
              <img src="../../assets/certificate-icon/num-icon.png" alt="" slot="prefix" >
            </el-input>
          </el-form-item>
          <el-form-item prop="manualCode">
            <div class="code-input">
              <el-input v-model="form.manualCode" placeholder="请填写验证码">
                <img src="../../assets/certificate-icon/code-icon.png" alt="" slot="prefix" >
              </el-input>
              <div class="code-img">
                <p>{{ form.code }}</p>
                <img src="../../assets/images/reset.png" alt="" class="refresh" @click="changeCaptchUrl"/>
              </div>
              <!-- <img src="../../assets/certificate-icon/refresh-icon.png" alt="" class="refresh" @click="changeCaptchUrl"/> -->
            </div>
          </el-form-item>
          <el-form-item>
            <p class="prompt">请输入姓名、身份证号、证书编号中的任意两项</p>
            <el-button type="primary" @click="submitForm('ruleForm')" class="search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="no-data" v-else>
      <img src="../../assets/image/pending-search.png" alt="">
      <p>维护中</p>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb'
import { queryCertificate, randomCode } from '@/api/certificate'
export default {
  name: 'Institutions',
  components: {
    Breadcrumb
  },
  data() {
    var validateCode = (rule, value, callback) => {
      if (value.toUpperCase() !== this.form.code) {
        callback(new Error('验证码错误，请填写正确的验证码'))
      } else {
        callback()
      }
    }
    var validateInput = (rule, value, callback) => {
      if ((this.form.name && this.form.idCard && !this.form.num) || (this.form.name && this.form.num && !this.form.idCard) || (this.form.idCard && this.form.num && !this.form.name) || (this.form.name && this.form.num && this.form.idCard)) {
        callback()
        return false
      } else {
        callback(new Error('请输入姓名、身份证号、证书编号中的任意两项'))
      }
    }
    return {
      open: true,
      breadList: [
        { label: '证书查询', path: '/certificate' }
      ],
      form: {
        name: '',
        num: '',
        code: '',
        idCard: '',
        manualCode: ''
      },
      rules: {
        name: [
          { validator: validateInput, trigger: 'blur' }
        ],
        num: [
          { validator: validateInput, trigger: 'blur' }
        ],
        idCard: [
          { validator: validateInput, trigger: 'blur' }
        ],
        manualCode: [
          { validator: validateCode, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.changeCaptchUrl()
  },
  methods: {
    // 勿动 能用就用吧 逻辑复杂
    clearRules(name) {
      if (name === 'name') {
        if (this.form.idCard && this.form.num) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        } else if (this.form[name] && this.form.idCard) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        } else if (this.form[name] && this.form.num) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        }
      } else if (name === 'idCard') {
        if (this.form.name && this.form.num) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        } else if (this.form[name] && this.form.name) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        } else if (this.form[name] && this.form.num) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        }
      } else {
        if (this.form.name && this.form.idCard) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        } else if (this.form[name] && this.form.name) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        } else if (this.form[name] && this.form.idCard) {
          this.$refs.ruleForm.clearValidate(['name', 'num', 'idCard'])
        }
      }
    },
    // 更换验证码
    changeCaptchUrl() {
      randomCode().then(res => {
        const { code, data } = res
        if (code === 0) {
          this.form.code = data
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          queryCertificate(this.form).then(res => {
            const { code, message } = res
            if (code === 0) {
              sessionStorage.setItem('form', JSON.stringify(this.form))
              this.changeCaptchUrl()
              this.$nextTick(() => {
                this.$router.push({
                  path: '/certificateDetail?n=1'
                })
              })
            } else {
              this.$message.error(message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  width: 1300px;
  margin: 40px auto 0;
  margin-bottom: 40px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  padding-bottom: 120px;
  .no-data {
    width: 304px;
    margin: 90px auto 0;
    text-align: center;
    img {
      margin-bottom: 30px;
    }
    p {
      color: #999;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
    .left {
      text-align: left;
      margin: 15px 40px;
    }
  }
  .breadcrumb {
    width: 100%;
  }
  .search-wrapper {
    margin-top: 10px;
    text-align: center;
    p {
      letter-spacing: 1px;
    }
    .title {
      color: #0853B6;
      font-size: 36px;
      font-weight: bold;
    }
    .sub-title {
      color: #666;
      font-size: 18px;
      font-weight: bold;
      margin-top: 18px;
      letter-spacing: 8px;
    }
    .line {
      width: 980px;
      height: 2px;
      background-color: rgba(0,0,0,.1);
      display: block;
      margin: 30px auto 36px;
    }
    .code-input {
      width: 320px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      .el-input {
        width: 190px;
      }
      .code-img {
        width: 115px;
        height: 40px;
        line-height: 40px;
        // background: linear-gradient(-90deg, #0D59BC 0%, #4E70F3 100%);
        background: linear-gradient(90deg, #2A59B8 0%, #536EE8 100%);
        // margin-left: 16px;
        padding: 0 5px 0 16px;
        display: flex;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        img {
          position: absolute;
          right: 12px;
          top: 10px;
          width: 20px;
          height: 20px;
        }
        p {
          color: #fff;
          font-size: 18px;
          font-weight: bold;
          // letter-spacing: 5px;
        }
      }
      .refresh {
        height: 38px;
        cursor: pointer;
      }
    }
    .el-form-item {
      margin-bottom: 16px;
    }
    ::v-deep .el-form {
      .el-form-item {
        position: relative;
      }
      .el-form-item__content {
        height: 40px;
        margin-left: 0 !important;
      }
      .el-form-item__error {
        // width: 260px;
        display: inline-block;
        height: 24px;
        line-height: 24px;
        color: #D00D0D;
        font-size: 12px;
        background: #F6D3D3;
        // border: 1px solid #D00D0D;
        // margin: 10px auto 0;
        // text-align: center;
        position: absolute;
        top: 10px;
        left: 50%;
        transform: translateX(170px);
        padding: 0 10px 0 24px;
        text-align: left;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 24px;
          height: 24px;
          background: url(../../assets/images/error.png) no-repeat;
          background-size: 24px;
        }
        // &:last-child {
        //   width: 200px;
        // }
      }
      .el-form-item.is-error {
        .el-input {
          border-color: #FF4E4E;
          .el-input__prefix {
            background-color: #FFA6A6;
          }
        }
      }
    }
    ::v-deep .el-input {
      width: 320px;
      height: 40px;
      font-size: 0;
      border: 2px solid #0861D5;
      box-sizing: border-box;
      .el-input__inner {
        height: 36px;
        padding-left: 56px;
        font-weight: bold;
        color: #666;
        border: none;
        font-size: 14px;
      }
      .el-input__prefix {
        width: 36px;
        height: 36px;
        line-height: 46px;
        background-color: #95C7FF;
        margin-left: -5px;
        img {
          height: 28px;
          position: absolute;
          top: 50%;
          left: 50%;
          right: 50%;
          bottom: 50%;
          transform: translateY(-50%) translateX(-50%);
        }
      }
    }
    .error {
      width: 272px;
      color: #D00D0D;
      font-size: 14px;
      background: rgba(208, 13, 13, 0.18);
      border: 1px solid #D00D0D;
      margin: 20px auto 0;
      i {
        color: #D00D0D;
      }
    }
    .prompt {
      margin-top: 15px;
      color: #0753B6;
      font-size: 14px;
      font-weight: normal;
    }
    .search {
      width: 320px;
      height: 44px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      background: linear-gradient(90deg, #0F59BE 0%, #4A6EEF 100%);
      border-radius: 30px;
      // margin-top: 16px;
    }
  }
  ::-webkit-input-placeholder {
    font-weight: normal;
  }
  :-moz-placeholder {
    font-weight: normal;
  }
  ::-moz-placeholder {
    font-weight: normal;
  }
  :-ms-input-placeholder {
    font-weight: normal;
  }
}
.mobile {
  width: auto;
  margin: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  .banner-logo {
    width: 100%;
    padding: 64px 0;
    margin-bottom: 34px;
    background-color: #4671eb;
    text-align: center;
    & > img {
      width: 88%;
    }
  }
  .search-wrapper {
    transform: scale(2);
    transform-origin: top;
    .line {
      width: 100%;
    }
    ::v-deep .el-form-item {
      margin-bottom: 34px;
      .el-form-item__error {
        display: block;
        width: 286px;
        top: 2px;
        position: relative;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
